import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT} from "../../../ab_testing/usp_listing_tile_ab_test";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {useOfferListingUspAnalyticsContext} from "../components/OfferListingUspAnalyticsProvider";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    amplitudeItemListContext: IAmplitudeItemListContext;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListContext: IAmplitudeItemListContext, offerIds: string[], variant: string) =>
    `${itemListContext.itemListId ?? ""}|${JSON.stringify(itemListContext.itemListName)}|${offerIds.join(",")}|${variant}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, amplitudeItemListContext, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone} = params;
    const uspAnalyticsContext = useOfferListingUspAnalyticsContext();

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const uspVariant = uspAnalyticsContext?.variant;
        const hasResolvedUspVariant = uspVariant === USP_LISTING_TILE_CONTROL_VARIANT || uspVariant === USP_LISTING_TILE_TREATMENT_VARIANT;

        if (!hasResolvedUspVariant || !uspAnalyticsContext) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext, offerIds, uspVariant);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListId: amplitudeItemListContext.itemListId,
            itemListName: amplitudeItemListContext.itemListName ?? "",
            isUspVariant: uspVariant === USP_LISTING_TILE_TREATMENT_VARIANT,
            addressContext: uspAnalyticsContext.addressContext,
            location: "listing_page",
            lat: latestQuery.lat,
            lng: latestQuery.lng
        });
    }, [
        isInitialOfferListFetchDone,
        requestState,
        isListingQuerySyncedWithRoute,
        offerIds.join(","),
        amplitudeItemListContext.itemListId,
        amplitudeItemListContext.itemListName,
        offers,
        uspAnalyticsContext
    ]);
};
import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT} from "../../../ab_testing/usp_listing_tile_ab_test";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {useOfferListingUspAnalyticsContext} from "../components/OfferListingUspAnalyticsProvider";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    amplitudeItemListContext: IAmplitudeItemListContext;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListContext: IAmplitudeItemListContext, offerIds: string[], variant: string) =>
    `${itemListContext.itemListId ?? ""}|${JSON.stringify(itemListContext.itemListName)}|${offerIds.join(",")}|${variant}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, amplitudeItemListContext, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone} = params;
    const uspAnalyticsContext = useOfferListingUspAnalyticsContext();

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const uspVariant = uspAnalyticsContext?.variant;
        const hasResolvedUspVariant = uspVariant === USP_LISTING_TILE_CONTROL_VARIANT || uspVariant === USP_LISTING_TILE_TREATMENT_VARIANT;

        if (!hasResolvedUspVariant || !uspAnalyticsContext) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext, offerIds, uspVariant);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListId: amplitudeItemListContext.itemListId,
            itemListName: amplitudeItemListContext.itemListName ?? "",
            isUspVariant: uspVariant === USP_LISTING_TILE_TREATMENT_VARIANT,
            addressContext: uspAnalyticsContext.addressContext,
            location: "listing_page",
            lat: latestQuery.lat,
            lng: latestQuery.lng
        });
    }, [
        isInitialOfferListFetchDone,
        requestState,
        isListingQuerySyncedWithRoute,
        offerIds.join(","),
        amplitudeItemListContext.itemListId,
        amplitudeItemListContext.itemListName,
        offers,
        uspAnalyticsContext
    ]);
};
